const supportBaseUrl = 'support.garmin.com/sas/connect/';

/**
 * Gets the link to an FAQ page
 *
 * @param {string} contentId the ID of the FAQ page
 * @returns the FAQ link
 */
export const getFaqLink = (contentId) => {
    return `//${supportBaseUrl}?contentId=${contentId}`;
};

/**
 * Gets the FAQ link for a device
 *
 * @param {string} serialNumber the device's serial number
 * @returns the FAQ link for the device
 */
export const getDeviceFaqLink = (serialNumber) => {
    return `//${supportBaseUrl}?serialNumber=${serialNumber}`;
};

/**
 * Gets the manuals link for a device
 *
 * @param {string} partNumber the device's part number
 * @returns the manuals link for the device
 */
export const getDeviceManualsLink = (partNumber) => {
    return `//${supportBaseUrl}?partNumber=${partNumber}&focus=manuals`;
};
